import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useTeamProfileFlag } from '@/hooks/useTeamProfileFlag';

/**
 * Guards team-profile pages behind `teamProfileWeb`: nothing until the flags arrive (so a hard
 * refresh doesn't bounce an allowed user), then home when the flag is off.
 */
export function TeamProfileRoute({ children }: { children: ReactNode }) {
  const { enabled, ready } = useTeamProfileFlag();
  if (!ready) return null;
  if (!enabled) return <Navigate to='/' replace />;
  return <>{children}</>;
}
